import { Children, ReactNode } from 'react';

const ReactUtils = {
    isReactNodeEmpty: (node: ReactNode): boolean => {
        // Treat empty string and 0 as empty if desired:
        if (node === '' || node === 0) {
            return true;
        }
        return Children.toArray(node).length === 0;
    },
};

export default ReactUtils;
